var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    staticClass: "api-client-form",
    attrs: {
      visible: _vm.showModal,
      title: _vm.$t.__("developerPage.ApiClientForm.creating_api_access")
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c("div", { staticClass: "dialog__default" }, [
              !_vm.oauthClient
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form",
                        {
                          ref: "apiAccessForm",
                          attrs: {
                            model: _vm.clientData,
                            inlineMessage: true,
                            labelPosition: "top"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "mb-2 bold",
                              attrs: {
                                error: _vm.errors.get("type"),
                                prop: "type"
                              }
                            },
                            [
                              _c("h3", [
                                _vm._v(_vm._s(_vm.$l10n.__("Type d'accès")))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "separator mb-5" }),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "mb-3",
                                  attrs: {
                                    label: "private",
                                    disabled: _vm.isEditedClient
                                  },
                                  model: {
                                    value: _vm.clientData.type,
                                    callback: function($$v) {
                                      _vm.$set(_vm.clientData, "type", $$v)
                                    },
                                    expression: "clientData.type"
                                  }
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.$l10n.__("Privé")))
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "grey mt-2 pl-4" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$l10n.__(
                                            "Accès API limité aux collaborateurs de votre compte SELLSY."
                                          )
                                        )
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$l10n.__(
                                            'Un flow "OAuth 2 authorization code" sera requis.'
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "mb-3",
                                  attrs: {
                                    label: "personal",
                                    disabled: _vm.isEditedClient
                                  },
                                  model: {
                                    value: _vm.clientData.type,
                                    callback: function($$v) {
                                      _vm.$set(_vm.clientData, "type", $$v)
                                    },
                                    expression: "clientData.type"
                                  }
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.$l10n.__("Personnel")))
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "grey mt-2 pl-4" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$l10n.__(
                                            "Accès API lié à un collaborateur."
                                          )
                                        )
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$l10n.__(
                                            'L\'utilisation du flow "OAuth 2 client credentials" est possible.'
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "mb-2",
                                  attrs: {
                                    label: "public",
                                    disabled: _vm.isEditedClient
                                  },
                                  model: {
                                    value: _vm.clientData.type,
                                    callback: function($$v) {
                                      _vm.$set(_vm.clientData, "type", $$v)
                                    },
                                    expression: "clientData.type"
                                  }
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.$l10n.__("Publique")))
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "grey mt-2 pl-4" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$l10n.__(
                                            "Accès API permettant de se connecter à tous les comptes SELLSY"
                                          )
                                        )
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$l10n.__(
                                            'Une validation de SELLSY et un flow "OAuth 2 authorization code" seront requis.'
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "separator mb-4" })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.oauthClient && _vm.clientData.type
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form",
                        {
                          ref: "accessTokenForm",
                          attrs: {
                            model: _vm.clientData,
                            inlineMessage: true,
                            rules: _vm.rules,
                            labelPosition: "top"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "mb-4",
                              staticStyle: { "font-size": "20px" },
                              attrs: {
                                error: _vm.errors.get("name"),
                                prop: "name",
                                label: _vm.$t.__(
                                  "developerPage.ApiClientForm.access_name"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "wp-10",
                                attrs: { maxlength: "150" },
                                model: {
                                  value: _vm.clientData.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.clientData, "name", $$v)
                                  },
                                  expression: "clientData.name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.clientData.type != "personal"
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "mb-4",
                                  attrs: {
                                    error: _vm.errors.get("redirectUri"),
                                    prop: "redirectUri",
                                    label: _vm.$t.__(
                                      "developerPage.ApiClientForm.redirect_link"
                                    )
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "wp-10",
                                    attrs: {
                                      type: "textarea",
                                      autosize: { minRows: 2, maxRows: 4 },
                                      placeholder: _vm.$t.__(
                                        "developerPage.ApiClientForm.enter_one_redirect_url"
                                      )
                                    },
                                    model: {
                                      value: _vm.clientData.redirectUri,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.clientData,
                                          "redirectUri",
                                          $$v
                                        )
                                      },
                                      expression: "clientData.redirectUri"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.clientData.type == "personal"
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "mb-4",
                                  attrs: {
                                    error: _vm.errors.get("staffId"),
                                    prop: "staffId",
                                    label: _vm.$t.__(
                                      "developerPage.ApiClientForm.select_linked_staff_to_api_access"
                                    )
                                  }
                                },
                                [
                                  _c("autocomplete-input", {
                                    attrs: {
                                      mode: "edit",
                                      placeholder: _vm.$t.__(
                                        "developerPage.ApiClientForm.linked_staff"
                                      ),
                                      options: _vm.staffs,
                                      multiple: false,
                                      labelColumn: "fullName",
                                      idColumn: "id"
                                    },
                                    model: {
                                      value: _vm.clientData.staffId,
                                      callback: function($$v) {
                                        _vm.$set(_vm.clientData, "staffId", $$v)
                                      },
                                      expression: "clientData.staffId"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.clientData.type == "personal"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t.__(
                                      "developerPage.ApiClientForm.remote_access"
                                    )
                                  }
                                },
                                [
                                  _c("p", { staticClass: "grey" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$l10n.__(
                                            "Cette fonctionnalité vous permet d'emprunter l'identité d'autres collaborateurs sur un même accès API. En passant le header `X-Switch-User` dans vos appels, ceux ci seront joués pour le compte du collaborateur passé en valeur de ce header."
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "grey" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$l10n.__(
                                            "A noter que seuls des collaborateurs avec le rôle administrateur peuvent générer ce type d'accès et emprunter ainsi l'identité de leurs collaborateurs."
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "bold grey" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$l10n.__(
                                            "Attention à n'utiliser cette option que si nécéssaire"
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex-level ai-center mt-2"
                                    },
                                    [
                                      _c("CompassSwitch", {
                                        attrs: {
                                          disabled: !_vm.isAdminAccess,
                                          size: "medium"
                                        },
                                        model: {
                                          value: _vm.clientData.delegated,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.clientData,
                                              "delegated",
                                              $$v
                                            )
                                          },
                                          expression: "clientData.delegated"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("label", { staticClass: "ml-2" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$l10n.__(
                                              "Activer l'accès délégué"
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.clientData.type !== "personal"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t.__(
                                      "developerPage.ApiClientForm.block_simultaneous_connections"
                                    )
                                  }
                                },
                                [
                                  _c("p", { staticClass: "grey" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$l10n.__(
                                            "Lorsqu'un nouvel access token est demandé pour cet accès par un utilisateur, tous ceux précédemment générés par ce même utilisateur seront révoqués"
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex-level ai-center mt-2"
                                    },
                                    [
                                      _c("CompassSwitch", {
                                        attrs: { size: "medium" },
                                        model: {
                                          value: _vm.clientData.singleLogin,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.clientData,
                                              "singleLogin",
                                              $$v
                                            )
                                          },
                                          expression: "clientData.singleLogin"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("label", { staticClass: "ml-2" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$l10n.__(
                                              "Bloquer les connexions simultanées"
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "mb-4",
                              attrs: {
                                error: _vm.errors.get("scopes"),
                                prop: "scopes"
                              }
                            },
                            [
                              _c("p", { staticClass: "bold fs-5 mb-3" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Choisissez les autorisations que vous voulez donner à votre accès API "
                                      )
                                    ) +
                                    "\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("input-scopes", {
                                attrs: {
                                  scopes: _vm.scopesTree,
                                  handleChecked: _vm.handleChecked
                                },
                                model: {
                                  value: _vm.clientData.scopes,
                                  callback: function($$v) {
                                    _vm.$set(_vm.clientData, "scopes", $$v)
                                  },
                                  expression: "clientData.scopes"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "aright mt-5" },
                            [
                              _c("CompassButton", {
                                attrs: {
                                  label: _vm.$t.__("common.actions.cancel"),
                                  type: "secondary"
                                },
                                on: { click: _vm.close }
                              }),
                              _vm._v(" "),
                              _c("CompassButton", {
                                attrs: {
                                  label: _vm.$t.__("common.actions.save"),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.submitForm("accessTokenForm")
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm.oauthClient
                ? _c("div", { staticClass: "mx-auto mt-4 wp-5" }, [
                    _c("p", { staticClass: "bold" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Ci-dessous le client oauth que vous avez généré."
                            )
                          ) +
                          "\n                    "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "alert alert-warning" }, [
                      _c("p", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$l10n.__(
                                "Assurez-vous de copier ces information maintenant. Vous ne serez pas en mesure de le voir à nouveau !"
                              )
                            ) +
                            "\n                        "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "bold" }, [_vm._v("Client id")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "copy-element" },
                      [
                        _c("pre", { staticClass: "token well" }, [
                          _vm._v(_vm._s(_vm.oauthClient.id))
                        ]),
                        _vm._v(" "),
                        _vm.oauthClient.id
                          ? _c("SaasClipboard", {
                              attrs: { data: _vm.oauthClient.id }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "bold" }, [_vm._v("Client secret")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "copy-element" },
                      [
                        _c("pre", { staticClass: "token well" }, [
                          _vm._v(_vm._s(_vm.oauthClient.secret))
                        ]),
                        _vm._v(" "),
                        _vm.oauthClient.secret
                          ? _c("SaasClipboard", {
                              attrs: { data: _vm.oauthClient.secret }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "aright mt-5" },
                      [
                        _c("CompassButton", {
                          attrs: {
                            label: _vm.$t.__("common.actions.close"),
                            type: "primary"
                          },
                          on: { click: _vm.close }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }